import React, { useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Typography } from '@comparethemarketau/manor-typography';
import { ReviewAndEditYourDetails } from '../../summary/common/review_and_edit_your_details';

const useStyles = createUseStyles((theme) => ({
    container: {
        backgroundColor: theme.colors.primary50,
        borderRadius: theme.borderRadius.default,
        padding: theme.spacing[12]
    }
}));

const ReviewNoticeCard = ({ className, textClassName }) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    return (
        <div className={classNames('test-emptyState-reviewNoticeCard', classes.container, className)}>
            <Typography className={textClassName}>
                {'This could be because you do not meet their underwriting requirements, or perhaps they do not have a suitable product for you based on the information provided.'}
            </Typography>
            <ReviewAndEditYourDetails />
        </div>
    );
};

ReviewNoticeCard.propTypes = {
    className: PropTypes.string,
    textClassName: PropTypes.string
};

export { ReviewNoticeCard };
